import { filter as adfFilter } from '@atlaskit/adf-utils/filter';
import type { DocNode } from '@atlaskit/adf-schema/doc';

export const getLinks = (content: DocNode) => {
	return adfFilter(content, (node) => (node.marks || []).some((mark) => mark.type === 'link'));
};
